<template>
  <div class="pb100">
    <crumbs detail="true"/>
    <div class="container">
      <div class="detailmodel2 clearfix plr30 ptb10">
        <h2 class="title pt40">{{ detail.title }}</h2>
        <div class="parambox clearfix">
          <ul class="otherparam clearfix">
            <li v-if="detail.updateTime">发布时间：{{ detail.date }}</li>
            <li v-if="detail.source">来源：{{ detail.source }}</li>
            <li><pv pvtype="1" :count="pv" pv-style="iconpv1"/></li>
          </ul>
          <cfont-size @fontsizeType="fontsizeType"/>
        </div>
        <div class="contentbox mtb2 min-height300" :class="fontsizetype" v-html="detail.content">
        </div>
        <comment v-if="detail" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        <right-sidebar
          @pvcount="pvcount"
          :comment-count="commentTotal"
          :comment-gotop="commentOffsettop"
          :comment-show="isCommentshow"
          :title="detail.title"
          :image="getImage(detail.image)"
          :url="this.$route.fullPath"
          ref="rightSidebar"></right-sidebar>
        <go-top></go-top>
      </div>
    </div>
  </div>
</template>

<script>
import { timeFormat } from '@/utils/validate'
import { getLiveDetail } from '@/api/live/index'
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import pv from '@/components/amount/pv'
import cfontSize from '@/components/selectfontsize/index'
import crumbs from '@/components/crumbs/index'
export default {
  name: 'livedetail',
  meta: {
    showHeader: true
  },
  components: {
    Comment,
    RightSidebar,
    goTop,
    pv,
    cfontSize,
    crumbs
  },
  data () {
    return {
      detail: '',
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      fontsizetype: ''
    }
  },
  mounted () {
    this.getDetail()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    fontsizeType (val) {
      this.fontsizetype = val
    },
    /* 浏览量 */
    pvcount (val) {
      this.pv = val
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    /* 获取信息详情 */
    getDetail () {
      getLiveDetail(this.$route.query.id).then((res) => {
        if (res.data.status === 200) {
          this.detail = res.data.data
          this.detail.updateTime = timeFormat(this.detail.updateTime, 'yymmddhhmm')
        } else {
          this.$message.error(res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/live/detail.vue